// Central place for AWS user role mappings
export const USER_ROLES_AWS_MAP = new Map([
  ['ROLE_TRIAL', 'TRIAL'],
  ['ROLE_ACADEMIC', 'ACADEMIC'],
  ['ROLE_STANDARD', 'STANDARD'],
  ['ROLE_PROFESSIONAL', 'ADVANCED'],
  ['ROLE_UNLIMITED', 'PREMIUM'],
  ['ROLE_DEVELOPER', 'DEVELOPER'],
]);

export default USER_ROLES_AWS_MAP;
